import { View, TouchableOpacity, ScrollView } from "react-native";
import { Icon as RawIcon } from "@ant-design/react-native";
import Icon from "@shared/components/md-design-system/Icon/Icon";
import { Head } from "@shared/components/head";
import { Text } from "@shared/components/text";
import Button from "@shared/components/md-design-system/Button/Button";
import { colorPalette } from "@shared/config/colorsConfig";
import { CenteredModal } from "@shared/components/CenteredModal";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";

interface AdherenceInfoModalProps {
    visible: boolean;
    onClose: () => void;
}

const POINTS = [
    { icon: 'safety-certificate', key: 'safety' },
    { icon: 'medicine-box', key: 'care' },
    { icon: 'check-circle', key: 'surprises' },
] as const;

export const AdherenceInfoModal = ({ visible, onClose }: AdherenceInfoModalProps) => {
    const { t } = dynamicTranslations();

    return (
        <CenteredModal visible={visible} onClose={onClose}>
            <View className="w-full bg-white rounded-[22px] max-h-[85%]">
                <TouchableOpacity
                    onPress={onClose}
                    className="absolute right-3 top-3 w-12 h-12 rounded-full bg-white border border-gray-300 items-center justify-center z-10"
                >
                    <RawIcon name="close" size={18} color={colorPalette.gray[500]} />
                </TouchableOpacity>

                <View className="px-7 pt-7">
                    <Head type="h2" className="mb-2 pr-14">{t('screens.activities.adherence.modalTitle')}</Head>
                </View>

                <ScrollView className="px-7" contentContainerStyle={{ paddingBottom: 24 }}>
                    <Text className="text-base text-black mb-5">{t('screens.activities.adherence.lead')}</Text>

                    <View className="flex-col gap-4 mb-2">
                        {POINTS.map(({ icon, key }) => (
                            <View key={key} className="flex-row items-start gap-4">
                                <View className="w-12 h-12 rounded-xl bg-secondary-100 items-center justify-center shrink-0">
                                    <Icon name={icon} size={22} color={colorPalette.secondary[600]} />
                                </View>
                                <View className="flex-1">
                                    <Text className="font-semibold text-base">
                                        {t(`screens.activities.adherence.points.${key}.title`)}
                                    </Text>
                                    <Text className="text-md text-gray-500 mt-1">
                                        {t(`screens.activities.adherence.points.${key}.description`)}
                                    </Text>
                                </View>
                            </View>
                        ))}
                    </View>

                    <View className="mt-2">
                        <Button size="large" variant="primary" onPress={onClose}>
                            {t('screens.activities.adherence.gotIt')}
                        </Button>
                    </View>
                </ScrollView>
            </View>
        </CenteredModal>
    );
};

export default AdherenceInfoModal;
